import Navigation from "../navigation";
import Url from "../utils/url";

class ExNavigation extends Navigation{
    constructor(xml) {
        super(xml);
    }

    /**
	 * Unpack navigation items
	 * @private
	 * @param  {array} toc
	 */
	unpack(toc) {
		var item;

		//加入tocByFilenameRange
		if(!this.tocByFilenameRange){
			this.tocByFilenameRange = {};
		}

		for (var i = 0; i < toc.length; i++) {
			item = toc[i];

			//加入預設 linear 屬性
			item.linear = true;

			if (item.href) {
				this.tocByHref[item.href] = i;

				let url = new Url(item.href);
				if(!this.tocByFilenameRange[url.filename]){
					this.tocByFilenameRange[url.filename] = {
						start: i,
						end: i,
						items: [{
							href:item.href,
							index:i
						}],
					}
				}else{
					this.tocByFilenameRange[url.filename].items.push({
						href:item.href,
						index:i
					});
					this.tocByFilenameRange[url.filename].end = i;
				}
                item.filename = url.filename;
			}

			if (item.id) {
				this.tocById[item.id] = i;
			}

			

			this.length++;

			if (item.subitems.length) {
				this.unpack(item.subitems);
			}
		}

	}

    /**
	 * Get an item from the navigation
	 * @param  {string} target
	 * @return {object} navItem
	 */
	get(target) {
		var index;

		if(!target) {
			return this.toc;
		}

		if(target.indexOf("#") === 0) {
			index = this.tocById[target.substring(1)];
		} else if(target in this.tocByHref){
			index = this.tocByHref[target];
		}

		return this.getByIndex(target, index, this.toc);
	}

    /**
	 * Get an item from navigation subitems recursively by index
	 * @param  {string} target
	 * @param  {number} index
	 * @param  {array} navItems
	 * @return {object} navItem
	 */
	getByIndex(target, index, navItems) {
		if (navItems.length === 0) {
			return;
		}

		const item = navItems[index];
		if (item && (target === item.id || target === item.href || target === item.filename)) {
			return item;
		} else {
			let result;
			for (let i = 0; i < navItems.length; ++i) {
				result = this.getByIndex(target, index, navItems[i].subitems);
				if (result) {
					break;
				}
			}
			return result;
		}
	}
}

export default ExNavigation;